import type { FaireProductEntity } from "../../entity_types/product";

export const p_xczueejznd: FaireProductEntity = {
  token: "p_xczueejznd",
  type: "product",
  name: "LOHN Candle - JARO Mandarin & Petitgrain",
  brandToken: "b_eyd2sh0t50",
  brandName: "LOHN (No duties | Ships from CAN/USA)",
  imageUrl: "https://cdn.faire.com/fastly/d00fc944e53d83960ccf6854fb723b8331e728a7140e701729d2dc5b0027c80e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d867d38bade0eed8c9e72ec97b581fe06839ce6eb56d6e7f63a823922189a089.png",
    "https://cdn.faire.com/fastly/5bcf5f0387bbf07b146d90c37fd88789885530690de9580715bbbefb5cfa0791.jpeg",
    "https://cdn.faire.com/fastly/6284d3ea0f4968ee56ba0d55895a5ed0d67bc98e93679e53995cf60a76709908.jpeg"
  ],
  priceDollars: 19,
  description: "Spring among the orange trees. Refreshing orange flower, woody petitgrain, fruity ylang ylang and a spritz of mandarin. Bright & elegant.\n\n7.5 oz. Clean burn for 50 hours. Vegan, cruelty-free, paraben-free, phthalate-free. Made in Canada.\n\nMade with a layered, phthalate-free fragrance, sustainable coconut and soy wax, a reusable, recyclable glass vessel, and a non-toxic, lead-free cotton wick.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:56.025Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
